// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import MainRoutes from './MainRoutes';
import { useModulePermission } from '../Helpers/customHooks/useModulePermission';

const ProtectedRoute = ({ children, requiredPermission }) => {
    const permissionInfo = useModulePermission(requiredPermission);


    if (!permissionInfo?.hasAccess) {
    // Redirect to unauthorized page with the return URL
    return <Navigate 
      to={MainRoutes.UNAUTHORIZED} 
      replace 
    />;
  }

  return children;
};

export default ProtectedRoute;